// 興味関心チェックreducer.
import * as InterestCheck from '../../constants/InterestCheck';

const initialState = {
  LoadedCount: 0,
};

export default function interestCheck(state: any = initialState, action: any) {
  switch (action.type) {
    case InterestCheck.LOADING:
      return Object.assign({}, state, {
        type: InterestCheck.LOADING,
        LoadedCount: 0,
      });
    case InterestCheck.FINISH:
      return Object.assign({}, state, {
        type: InterestCheck.FINISH,
        LoadedCount: state.LoadedCount + 1,
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/InterestCheck.tsx